export default "__VITE_ASSET__DEwJyB$G__"